import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";
import ImageGallery from 'react-image-gallery';
import "./../image-gallery.css";
import {Link} from "react-router-dom";

export default () => {
    const title = 'Беловежская пуща';

    const images = [
        {
            original: require('./../img/virtualtours/belpuscha/belp000.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp000.jpg'),
            description: 'Ворота. Беловежская пуща – это остаток огромного лесного массива, располагавшегося на территории Европы от Балтики до Черного моря. Первые упоминания об этой территории встречаются еще во II веке в сочинениях Геродота. Сведения о пуще как старом девственном лесу имеются в Ипатьевской летописи 983 года.',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp001.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp001.jpg'),
            description: 'Муравейник',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp002.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp002.jpg'),
            description: 'Сосны. Хвойные породы представлены сосной обыкновенной и елью европейской, а также редкой в регионе пихтой белой. Вблизи южной окраины пущи проходит граница сплошного распространения ели. Лиственные представляют: дуб черешчатый, березы повислая и пушистая, граб, ольха черная, ясень обыкновенный осина. Значительно реже встречаются дуб скальный, вязы шершавый и гладкий.',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp003.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp003.jpg'),
            description: 'Лесник. Вокруг Беловежской пущи учреждена охранная зона площадью 90 тысяч гектаров. Протяжённость с севера на юг 68 км, с запада на восток от 6 до 32 км. В Польше на части территории пущи создан национальный парк (площадь 5 тысяч гектаров).',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp004.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp004.jpg'),
            description: 'Лиственный лес. Благодаря разнообразию древесных пород, мягкому и влажному климату, невмешательству человека в ход естественных процессов, большая часть лесов имеет смешанный состав и отличается своей пестротой.',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp005.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp005.jpg'),
            description: 'Папоротник',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp006.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp006.jpg'),
            description: 'Дуб Патриарх',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp007.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp007.jpg'),
            description: 'Дуб Патриарх',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp008.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp008.jpg'),
            description: 'Дуб Патриарх',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp009.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp009.jpg'),
            description: 'Сосна Великан',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp010.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp010.jpg'),
            description: 'Сосна Великан',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp011.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp011.jpg'),
            description: 'Беловежская пуща',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp012.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp012.jpg'),
            description: 'Бальзам. Melittis sarmatica. Редкий вид, находящийся под угрозой прямого истребления. В Белоруссии проходит восточная граница его ареала. Занесён в Красную книгу БССР. Сокращение численности вызвано сбором растений в качестве лекарственного сырья, изменением мест произрастания под влиянием хозяйственного освоения территорий.',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp013.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp013.jpg'),
            description: 'Лесные цветы',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp014.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp014.jpg'),
            description: 'Мох',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp015.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp015.jpg'),
            description: 'Пруд',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp016.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp016.jpg'),
            description: 'Лебедь-шипун. В Беловежской пуще и ее окрестностях учтено 227 видов птиц, 40 из них занесены в Красную книгу Республики Беларусь. В герпетофауне насчитывается 11 видов земноводных и 7 видов пресмыкающихся. В водоемах обитает 24 вида рыб. Наиболее многочисленны щука, плотва, линь, ерш, окунь. Беловежская пуща имеет богатейшую фауну беспозвоночных. Только насекомых здесь насчитывается около 8500 видов.',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp017.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp017.jpg'),
            description: 'Беловежская пуща. Естественных озер на территории пущи нет. Среди десяти искусственных прудов наиболее крупные созданы в пойме реки Переволока (озера Лядское - 345 га, Хмелевское - 75 га), где на пролетах останавливается большое количество водоплавающей дичи.',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp018.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp018.jpg'),
            description: 'Лебедь-шипун',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp019.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp019.jpg'),
            description: 'Плющ. Hedera. род вечнозелёных лиан семейства аралиевых. 15 видов, распространены в Евразии. В Беларуси отмечен плющ обыкновенный, редкий реликтовый вид, занесён в Красную книгу Беларуси. Растёт в тенистых лиственных лесах. В естественных условиях Беларуси не цветёт. Зимует только под снегом. Выращивают как декоративное и комнатное растение. Стебель длиной 3 - 5 (иногда до 20 и более) м, цепляется за деревья многочисленными воздушными корнями-присосками. Листья цельные или 3 - 5-лопастные, кожистые, сверху блестящие. Цветки зеленоватые, в шаровидных зонтиках, собранных в кистевидные или метельчатые соцветия. Плод ягодовидный.',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp020.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp020.jpg'),
            description: 'Беловежская пуща',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp021.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp021.jpg'),
            description: 'Беловежская пуща',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp022.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp022.jpg'),
            description: 'Беловежская пуща',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp023.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp023.jpg'),
            description: 'Беловежская пуща',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp024.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp024.jpg'),
            description: 'Купальня диких кабанов',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp025.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp025.jpg'),
            description: 'Беловежская пуща',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp026.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp026.jpg'),
            description: 'Лесничество',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp027.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp027.jpg'),
            description: 'Лось',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp028.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp028.jpg'),
            description: 'Рысь',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp029.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp029.jpg'),
            description: 'Зубр',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp030.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp030.jpg'),
            description: 'Зубр',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp031.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp031.jpg'),
            description: 'Зубр',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp032.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp032.jpg'),
            description: 'Экскурсия',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp033.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp033.jpg'),
            description: 'Лаборатория. Национальный парк Беловежская пуща - это крупная природная научная лаборатория, которая привлекает к себе ученых из многих стран.',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp034.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp034.jpg'),
            description: 'Ежик',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp035.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp035.jpg'),
            description: 'Теннисный корт. Спортивный комплекс национального парка к услугам любителей спорта представляет теннисные корты, биллиардную комнату, площадки для игры в мини-футбол, гандбол, волейбол, баскетбол.',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp036.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp036.jpg'),
            description: 'Скульптура',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp037.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp037.jpg'),
            description: 'Музей Беловежская пуща',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp038.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp038.jpg'),
            description: 'Заболоченный участок. Уникальный лесной массив, один из самых крупных и старых в Европе. Пуща включена в 1992 году ЮНЕСКО в список мирового наследия.',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp039.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp039.jpg'),
            description: 'Гостиница',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp040.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp040.jpg'),
            description: 'Гостиница',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp041.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp041.jpg'),
            description: 'Символ пущи',
        },
        {
            original: require('./../img/virtualtours/belpuscha/belp042.jpg'),
            thumbnail: require('./../img/virtualtours/belpuscha/mbelp042.jpg'),
            description: 'Въезд',
        },
    ];

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <div className="onehalf-col-cell">
                        <h2>{title}</h2>
                        <ImageGallery
                            items={images}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                </div>

                <div className="pageitem">
                    <p>Беловежская пуща – это остаток огромного лесного массива, располагавшегося на территории Европы
                        от Балтики до Черного моря. Первые упоминания об этой территории встречаются еще во II веке в
                        сочинениях Геродота. Сведения о пуще как старом девственном лесу имеются в Ипатьевской летописи
                        983 года.</p>
                    <p>В киевских летописях указывается, что территория нынешней пущи населялась воинственным литовским
                        племенем ятвягов, которые занимались охотой и рыбной ловлей. Киевский князь Владимир в 983 г.,
                        защищая земли Руси от набегов, разбивает ятвягов. Этим было положено начало вытеснения их из
                        пущи. Несмотря на упорное и мужественное сопротивление в течение почти 300 лет, ятвяги в конце
                        XIII века все же были уничтожены. В XIIв. в Беловежской пуще подолгу жил Владимир Мономах,
                        охотясь на зубров, туров, оленей. В охоте он видел не только забаву, но и труд, закалявший
                        воинов и приучавший их мастерски владеть оружием. В XIII веке пуща подверглась нашествию татар и
                        немецких рыцарей. И только с конца XIII столетия пуща стала называться
                        Каменецко-Беловежской.</p>
                    <p>Хвойные породы представлены сосной обыкновенной и елью европейской, а также редкой в регионе
                        пихтой белой. Вблизи южной окраины пущи проходит граница сплошного распространения ели.
                        Лиственные представляют: дуб черешчатый, березы повислая и пушистая, граб, ольха черная, ясень
                        обыкновенный осина. Значительно реже встречаются дуб скальный, вязы шершавый и гладкий.</p>
                    <p>Вокруг Беловежской пущи учреждена охранная зона площадью 90 тысяч гектаров. Протяжённость с
                        севера на юг 68 км, с запада на восток от 6 до 32 км. В Польше на части территории пущи создан
                        национальный парк (площадь 5 тысяч гектаров).</p>
                    <p>Благодаря разнообразию древесных пород, мягкому и влажному климату, невмешательству человека в
                        ход естественных процессов, большая часть лесов имеет смешанный состав и отличается своей
                        пестротой. Основные породы – сосна, ель, дуб (спальный и черешчатый), ясень, граб, береза,
                        ольха, осина. Встречаются также кллен, липа, вяз, ильм, ива и др. Отличительная черта лесов –
                        наличие многовековых многоярусных группировок - почти 3/5 всех древостоев пущи относятся к
                        группе старовозрастных (до 200-500 лет), немногим более 1/5 представлено молодняком (до 40 лет).
                        Здесь же встречаются деревья-гиганты, имеющие возраст в несколько сот лет.</p>
                    <p>Рельеф — холмистая равнина. Самая возвышенная часть — центральная, на юго-востоке — Беловежская
                        гряда. Климат умеренно тёплый. Крупнейшие реки (бассейн Западная Буга): Нарев, Неравна, Рудовка,
                        Гвозна, Правая и Левая Лесная. Озёра: Лядское и Переволока (искусственные). Почвы на севере и
                        юге преимущественно дерново-подзолистые, в центральной части бурые лесные, в низинах встречаются
                        болотные и торфяно-глеевые.</p>
                    <p>Во флоре пущи 844 вида высших растений, 220 видов мохообразных, около 250 видов лишайников, 159
                        видов трутовых грибов. Основные лесообразующие породы; сосна, ель, ольха, береза, дуб и другие.
                        58 видов кустарников, кустиков и полукустарников. Лес занимает 88,2%, болота 4%, луга 5%
                        территории. Выделяют 12 типов леса. Преобладают боры (около 60% лесопокрытой площади),
                        преимущественно моховые и черничные. Растёт 26 видов деревьев. Леса принадлежат к старейшим в
                        Европе. Возраст боров достигает 180—200 лет, ельников 120—160 лет, дубрав 180— 220 лет.
                        Сохранились отдельные деревья-гиганты: сосна (возраст 350 лет, высотой около 35 м), ель (200
                        лет, высотой 52 м), дуб (500 лет, диаметром до 190 см) и другие. В фауне 59 видов млекопитающих,
                        226 птиц, 11 земноводных, 7 пресмыкающихся, около 30 рыб и 8,5 тысяч видов насекомых.
                        Беловежская пуща — последнее природное местопребывание самого крупного представителя современной
                        европейской фауны — зубра (около 160 особей). В пуще около 2 тысяч благородных оленей, 1,5 тысяч
                        косуль, 100 лосей, около 2 тысяч кабанов. До начала 17 века встречался тур, до начала 19 века —
                        лесной тарпан. С конца 19 века делались попытки акклиматизации лани (исчезла в начале 1930-х
                        годов), в 1962 завезены 5 тарпановидных лошадей из Польши. За последние годы в зоопарки,
                        заповедники, охотничьи хозяйства СНГ, Германии, Чехии, Польши вывезены 114 зубров, 1139 оленей,
                        730 кабанов и другие. Бурый медведь истреблён в середине 19 века, волк заходит из других
                        районов. В небольшом количестве (20—30 животных) встречается рысь. Водятся лисица, барсук, хорь,
                        горностай, ласка, куница, енотовидная собака, выдра, бобр (реакклиматизирован в 1956 году),
                        зайцы русак и беляк (редок), белка, мыши желто-горлая, лесная и полевая, сони полчок,
                        орешниковая и лесная, полёвки, лесная мышовка, крот, землеройки, летучие мыши (13 видов) и
                        другие. В орнитофауне встречаются виды, типичные для Западной Европы (красный коршун), северные
                        таёжные (трёхпалый дятел), птицы южного широколиста, лесов (дятлы зелёный и седой). Обитают
                        аисты белый и чёрный, гоголь, 20 видов Хищных птиц. Много боровой дичи. Среди земноводных и
                        пресмыкающихся — лягушки прудовая, травяная и остромордая, жабы серая, зелёная и камышовая,
                        чесночница, жерлянка и другие. Беловежская пуща — уникальный памятник природы, на территории
                        которого много достопримечательностей.</p>
                    <p>Составлен список 110 редких растений пущи, подлежащих особой охране, 44 вида растений и 14 видов
                        животных занесены в Красную книгу Беларуси. Интересные биологические объекты — воротничковая
                        сосна (с пластинками коры в виде воротничка), плакучая форма ели, сросшиеся дубки-братья,
                        папоротниковые заросли чистоуста, участки пихты белой и дуба скального. Первая научная работа с
                        информацией о пуще опубликована в 1741. Здесь работали многие известные учёные, в том числе Ю.
                        Пачосский, Н. М. Кулагин в составе научного отдела лаборатории лесоведения Беловежской пущи,
                        экологии диких животных, охраны леса. Работает музей природы. Организован Телеханский филиал
                        Беловежской пущи на Выгонощанском озере.</p>
                    <p>БЕЛОВЕЖСКАЯ ПУЩА крупный лесной массив на территории Каменецкого, Пружанского и Свислочского
                        района (в 60 км от Бреста, 20 км от Каменца), вдоль государственной границы, на водоразделе
                        бассейнов Нёмана, Западного Буга и Припяти, частично на территории Польши; один из самых старых
                        лесных заповедников Европы. Площадь около 145 тысяч гектаров. Название, возможно образовано от
                        названия оборонительной башни (Белой вежи), построенной в 13 веке в Каменце. 25.12.1939
                        Беловежская пуща объявлена государственным заповедником, важнейшие задачи которого — сохранение
                        в естественном состоянии типичного для юго-западной Беларуси природного комплекса, сохранение и
                        восстановление редких и исчезающих видов диких животных и растений, изучение природных
                        процессов, пропаганда идей охраны природы. С 1957 – государственное заповедно-охотничье
                        хозяйство. Административно-хозяйственный и научный центр находится в деревне Каменюки
                        Каменецкого района. Площадь в Беларуси 87,6 тысяч гектаров, в том числе абсолютно заповедной
                        территории 7,7 тысяч гектаров.</p>
                    <p>Первые ограничения на охоту в лесах пущи введены в 13 веке. С конца 14 веке Беловежской пуще
                        превращена в заповедный лесной массив с правом охоты только для привилегированных лиц. В 1541
                        создан охотничий заказник для охраны зубров. В 1640 издан указ о запрещении выручки леса, в 1641
                        составлено описание пущи (в то время её площадь составляла 163,9 тысяч гектаров). Роскошные
                        королевские охоты наносили ущерб фауне (например 27.9.1752 убиты 42 зубра, 18 зубриц и 6 телят,
                        много других животных). В первой половине 18 века уничтожен благородный олень. С 1795
                        Беловежская пуща— охотничье хозяйство русских царей. В 1802 издан указ о заповедании пущи и
                        сохранении зубров, налажен их учёт, но вырубки леса продолжались. В 1842—1847 годах проведено
                        первое лесоустройство Беловежской пущи (площадь пущи в то время 121,4 тысяч гектаров).
                        Проводилась регулярная подкормка зубров, но в результате царских охот их численность сокращалась
                        (например 6-7.10.1860 убиты 28 зубров), в 1884 учтены 384 животных. В 1867 в Беловежской пуще
                        завезены 18 европейских благородных оленей и начаты работы по их акклиматизации. Большой ущерб
                        пуще нанесли первая мировая и Гражданская войны (в 1919 убит последний зубр, вырублено и
                        вывезено в Германию более 4,5 миллионов м3 ценной древесины). В 1921 выделен заповедный участок
                        пущи (площадь 4594,6 гектаров) и организован национальный парк, начались работы по
                        восстановлению зубра. В советское время установлена полная заповедность всей территории
                        Беловежской пущи в Беларуси, проводились работы по сохранению н изучению природных комплексов
                        этого уникального лесного массива. В период немецко-фашистской оккупации хозяйству заповедника
                        нанесён значительный ущерб. Деятельность заповедника возобновилась в октябре 1944.</p>
                    <Link to='/topic-melittis-sarmatica'>КАДИЛО САРМАТСКОЕ. Melittis sarmatica. КАДЗІЛА САРМАЦКАЕ</Link>
                    <p>Пуща - это оригинальный природный комплекс. Располагается она как бы на стыке разных растительных
                        зон. Здесь соседствует дуб скальный и плющ обыкновенный с ивой лапландской и березой карликовой.
                        Манжетка балтийская растет в пуще в 250 километрах к западу от границ своего основного ареала, а
                        осока болотолюбивая - в 380 километрах к югу. Здесь встречаются редчайшие растения: валериана
                        двудомная и астрогал песчаный, странной черноволосой формы. Необычайное сочетание растений -
                        представителей юга, и севера, приморского и континентального климата - характерная черта
                        растительности пущи.</p>
                    <p>Белорусы совместно с поляками превращают Беловежскую пущу в объект экотуризма</p>
                    <p>Как-то специалисты Беловежской пущи замерили, сколько патогенных микробов находится в кубометре
                        пущанского воздуха. Оказалось, в полтора раза меньше, чем в операционной палате после
                        стерилизации.</p>
                    <p>В Беловежской пуще и ее окрестностях учтено 227 видов птиц, 40 из них занесены в Красную книгу
                        Республики Беларусь. В герпетофауне насчитывается 11 видов земноводных и 7 видов пресмыкающихся.
                        В водоемах обитает 24 вида рыб. Наиболее многочисленны щука, плотва, линь, ерш, окунь.
                        Беловежская пуща имеет богатейшую фауну беспозвоночных. Только насекомых здесь насчитывается
                        около 8500 видов.</p>
                    <p>Естественных озер на территории пущи нет. Среди десяти искусственных прудов наиболее крупные
                        созданы в пойме реки Переволока (озера Лядское - 345 га, Хмелевское - 75 га), где на пролетах
                        останавливается большое количество водоплавающей дичи.</p>
                    <p>Беловежская пуща шесть раз объявлялась заповедной территорией (впервые в XVI веке), и никогда не
                        была настоящим заповедником. Это главный миф о Пуще. В Беловеже не природу оберегали, здесь
                        хозяйничали и охотились: лес рубили при царе, рубили при поляках, рубили в немецкой оккупации,
                        при советах тоже рубили. Когда мы ездили по заповеднику, нам указали на большую поляну вдоль
                        дороги: «Здесь немцы проложили железную дорогу и именно в этом месте грузили лес. В земле
                        остался такой пласт коры и опилок, что через полсотни лет ни одно деревце не продралось». За два
                        года до этого в 1939 году Беловежская пуща получила статус заповедника. После войны директора
                        «заповедника» менялись каждые три-шесть месяцев. Расстрельная это была должность. Райкомы и
                        райисполкомы требовали древесину: надо людям отстраиваться, в землянках живут. Так что саботажем
                        считались не вырубки заповедного леса, а запрет проводить эти вырубки. Это чудо, что при всем
                        этом в Беловежской пуще сохранился реликтовый лес.</p>
                    <Link to='/topic-hedera'>ПЛЮЩ (Hedera)</Link>
                    <p>С целью сохранения биологического разнообразия Беловежской пущи, вся территория ее разделена на 4
                        функциональные зоны с различным режимом охраны: </p>
                    <ul>
                        <li>заповедная зона - зона нетронутой природы, где запрещаются все виды хозяйственной и иной
                            деятельности, за исключением научных исследований и охраны (15677 га в основном коренных
                            естественных старовозрастных хвойно-широколиственных лесов);
                        </li>
                        <li>зона регулируемого пользования - 57000 га (все мероприятия в этой зоне должны обеспечивать
                            оптимальные условия для развития природных экосистем с целью сохранения и эволюционного
                            развития генофонда растительного и животного мира);
                        </li>
                        <li>рекреационная зона - 10712 га (ландшафты зоны отличаются высокими эстетическими
                            санитарно-гигиеническими свойствами и предназначены для ознакомления с
                            достопримечательностями парка, организованного познавательного туризма, рекреации и изучения
                            рекреационных нагрузок на экосистемы);
                        </li>
                        <li>хозяйственная зона - 3969 га (предназначена для размещения объектов административного и
                            рекреационного назначения, приема и обслуживания туристов, проживания и осуществления
                            хозяйственной деятельности сотрудников парка). Кроме того, вокруг парка создана, так
                            называемая, охранная или буферная зона площадью около 90 тыс. га, где земли сохраняются за
                            пользователями, но имеется ряд ограничений хозяйственной деятельности.
                        </li>
                    </ul>
                    <p>Но естественный облик пущи сохранился до сих пор. Это дикий лес! Кругом сосны, многовековые дубы,
                        остроконечные ели, бурелом и ветровал, покрытые мхом и лишайниками. Отдельным деревьям по
                        600-700 лет. Они уже одряхлели и стали дуплисты... Но жизнь в пуще не затухает. На почве,
                        удобренной вымершими великанами, на самих «древесных могилах» ютятся куртинки молодого леса;
                        изумительна и непреодолима сила лесовозобновления - здесь нет ни пустырей ни даже прогалин!</p>
                    <p>Фауна пущи насчитывает более 10 тыс. видов. Здесь обитает 59 видов млекопитающих, в том числе
                        самый крупный представитель современной европейской фауны - зубр. Наиболее многочисленны грызуны
                        - 20 видов. Среди них наиболее примечательным является бобр. Из хищников в пуще обитают волк,
                        лисица, рысь, куница лесная. Крупные копытные - дикий кабан, олень благородный, косуля, лось -
                        являются охотничьими видами и численность их оптимизируется. Зубр в прошлом также являлся
                        охотничьим видом, но к 1919 году был полностью истреблен. Проводимые биотехнические мероприятия
                        позволили восстановить поголовье и довести численность зубра в пуще до 300 особей.</p>
                    <p>Лесные насаждения необычайно богаты. В них выделено около 75 основных типов леса. Большую
                        половину всей лесной площади занимает сосна, остальную часть территории - ольха, ель, береза,
                        дуб. На севере - в Бровском, Свислочском, Никорском и на юге - в Пашуковском и Ясенском
                        лесничествах больше сосновых чистых и смешанных с елью и березой насаждений. В центральной части
                        - в Язвинском, Хвойникском и Королево-Мостовском лесничествах широко распространены еловые,
                        черноольховые, а также широколиственные насаждения.</p>
                    <p>Сегодня поохотиться в Беловежской пуще (охотхозяйство Шерешево) не каждому по карману. Завалить
                        царя Беловежских лесов стоит от 3800 евро. В таком трофее нет ничего необычного. Зубров
                        развелось слишком много для здешних лесов (численность зубров превышает норму на 70 голов),
                        многие старые самцы больны инфекцией, приводящей к импотенции. Сами не могут и молодых к самкам
                        не подпускают. Приходится таких отстреливать, для чего созывается специальная комиссия, которая
                        выносит приговор или жалует помилование.</p>
                    <p>Богатая разнообразная растительность Беловежской пущи создает прекрасные условия и для обитания
                        многочисленных диких животных. Фауна насчитывает 55 видов млекопитающих, 22 вида птиц, 11 видов
                        земноводных, 7 видов пресмыкающихся. Среди животных пущи – зубр, олень, косуля, дикий кабан,
                        лось, бобр, ондатра, выдра, рысь и др.</p>
                    <p>Микола Гусовский (Песнь про зубра):</p>
                    <blockquote>
                        Телом своим монолитным громаден настолько,<br/>
                        Что когда ранен смертельно, колена преклонит и стихнет.<br/>
                        Трое охотников смогут усесться на лбу меж рогами<br/>
                        Если же мне попытаться сравнить его шею и морду,<br/>
                        То опасаюсь – таких не сыскать пожалуй.<br/>
                        Клок бородищи торчит из-под челюсти рыжим мочалом,<br/>
                        Гроз полыханье в глазах и застывшая злоба;<br/>
                        Космами грива до самых лопаток спадает,<br/>
                        Донизу лоб, и колени, и грудь покрывал,<br/>
                        Если же будет угодно сравненье великого с малым<br/>
                        И коль подходит здесь местное наше сравненье, -<br/>
                        Это ж козел бородатый с нагуленным телом.<br/>
                        Вот он какой, наш бизон, именуемый зубром.
                    </blockquote>
                    <p>Наша Нива: ЗУБРЫ — найбольшые памеж зьвероў, якие ёсць цяпер у Эўропи. Кались яны жыли близка на
                        ўсей Эўропи, але памалу згинули. Цяпер жывуць тольки ў Велавежскай пуш-чы—ў Гродзенскай губ.,
                        дый то их тамака ўсяго каля 350 штук.—Зубр падобны трохи да быка дзикаго, тольки з горбам и
                        грывай, ды барадой лахматай; ўвесь абросшы доўгай шэрсцью. Жыве ён доўга—па 30—50 гадоу. Стары
                        зубр бывае даўжыни каля 5 аршыноў, а важыць 30 або 40 пудоў.</p>
                    <p>Но более всего знаменита пуща зубрами - современниками мамонтов. С этими животными связана вся ее
                        история. Говорят, что именно зубры «спасли» пущу, а она сохранила их.</p>
                    <p>Национальный парк Беловежская пуща - это крупная природная научная лаборатория, которая
                        привлекает к себе ученых из многих стран.</p>
                    <p>В центре пущи находится маленькая деревушка Вискули, где в 50-е годы был построен привлекательный
                        дворец, служивший резиденцией руководителей бывшего СССР, а теперь Беларуси. В 1991 г. здесь
                        было подписано известное «Беловежское» соглашение о выходе независимых республик из состава
                        СССР, после чего Вискули получили мировую известность.</p>
                    <p>Спортивный комплекс национального парка к услугам любителей спорта представляет теннисные корты,
                        биллиардную комнату, площадки для игры в мини-футбол, гандбол, волейбол, баскетбол.</p>
                    <p>Адрес Деда Мороза: 225063, Республика Беларусь, Брестская область, Каменецкий район, Беловежская
                        пуща.</p>
                    <p>Большой популярностью в пуще пользуется музей, расположенный в поселке Каменюки Каменецкого
                        района Брестской области. Здесь представлены экспонаты большинства обитающих в пуще животных и
                        произрастающих на территории пущи растений, а также открытые вольеры с различными видами
                        животных в их естественной среде обитания. Здесь можно получить любую справку о Беловежской пуще
                        - рассказ ведут опытные экскурсоводы, научные работники.</p>
                    <p>Национальный парк располагает большими возможностями для развития экологического туризма. Для
                        различных категорий посетителей предлагаются пешие, конные, автомобильные одно- и многодневные
                        туристические маршруты. Имеются три гостиницы на 212 мест, два гостевых комфортабельных домика в
                        живописных местах на 16 мест, сауна, бар, дискотека, ресторан, где можно отведать национальные
                        блюда, в том числе приготовленные из мяса дичи. Недалеко от гостиницы находится таксидермическая
                        и художественная мастерские, в которых изготавливаются оригинальные сувениры, предназначенные
                        для реализации посетителям на память о пребывании в Беловежской пуще.</p>
                    <p>Уникальный лесной массив, один из самых крупных и старых в Европе. Пуща включена в 1992 году
                        ЮНЕСКО в список мирового наследия. Пуща известна как уникальное место, где сохранились стада
                        величественных зубров, благородных оленей, косуль, диких кабанов. В советское время пуще был дан
                        статус элитарного заповедно-охотничьего хозяйства для высокопоставленных чиновников, для которых
                        была построена резиденция Вискули. Именно здесь в 1991 году были подписаны документы о
                        прекращении существования Советского Союза. В пуще действует прекрасный музей Природы, есть
                        вольеры с животными. Зимой здесь - резиденция белорусского Деда Мороза, который обещает всем
                        праздничное настроение и подарки</p>
                    <p>Беловежская пуща замечательна и тем, что здесь побывали все князья Великого Княжества Литовского
                        и все короли Речи Посполитой, а с XIX века и все российские императоры. Повод приехать у всех
                        был один - великолепие княжеской, королевской и императорской охоты.</p>
                    <p className="sub">Уладзiмiр Караткевiч, ПРАДМОВА ДА КНІГІ «БЕЛАВЕЖСКАЯ ПУШЧА»:</p>
                    <blockquote>
                        На самым захадзе маёй Беларусі ляжыць Белавежская пушча. Гэта адзін з апошніх астравоў таго
                        першабытнага лесу, які пакрываў у старадаўнія часы ўсю Еўропу. Тут зусім не рэдкасць дрэвы ў
                        паўтысячы год. Тут з незапамятных часоў вольна жыве зубр. Магутны, як сама зямля, і старажытны,
                        як яе запаветныя нетры.<br/>
                        Адвечная цішыня. I шолах дрэў. I тупат зубрыных статкаў. Таксама як і ў каменным веку.<br/>
                        I побач з гэтым сляды далікатнага любоўнага ўмяшання чалавека: стагі, каб падкармідь узімку
                        звяроў, музей, хаткі егераў, сучасная гасцініца. Для праўнукаў сваіх беражэ чалавек кожную
                        кветку, кожнае дрэва, жывёл і птушак.<br/>
                        I такуюць, такуюць раніцай глушцы. Да штучнага возера цягнуцца дяжкія сляды япрукоў. Трубіць ў
                        нясытай страсці алень. Дзікі вінаград абвівае буралом. I палюе на янотаў егер. I клічуць-клічуць
                        белыя лебедзі, б'юць на рэках пудовыя шчупакі, шумяць сонечныя дубы і грабы. I чырванеюць
                        падасінавікі. I дымок ад ранішняга вогнішча змешваецца з туманам.<br/>
                        Усе тэта — пушча. Усе тэта — неўміручая душа яе. Яна цудоўная, як душа нашага народа. Калі вы
                        стаміліся, калі хочаце прыпасці вуснамі да вечна жывой крыніцы жыцця — прыйдзіце сюды, у
                        найдзівоснейшы куток зямлі. Бо тут — фарпост чалавечнасці, літасці чалавека да прыроды, сястры
                        нашай.
                    </blockquote>
                    <Link to='/topic-nashaniwa-belpuscha-1908'>БЕЛАВЕЖСКАЯ ПУШЧА</Link>
                </div>
            </div>
        </>
    );
}